import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core'
import PersonIcon from '@material-ui/icons/Person'

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    boxShadow: '0 1px 7px 0 rgba(0,0,0,0.1)'
  },
  avatar: {
    background: 'linear-gradient(45deg, #063bc4, #680fad)',
    height: 45,
    width: 45
  }
}))

const TasksProgress = ({ className, data, ...rest }) => {
  const classes = useStyles()

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardContent>
        <Grid container justify="space-between" spacing={3}>
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              style={{ fontSize: '1rem' }}>
              Total Online Patient
            </Typography>
            <Typography color="textPrimary" variant="h5">
              {data?.tele_patient ? data?.tele_patient : '0'}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <PersonIcon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

TasksProgress.propTypes = {
  className: PropTypes.string
}

export default TasksProgress
